import { useState } from "react";
import type { FarmAndRetreatsFormState } from "../userForm.types";

const initialFormState: FarmAndRetreatsFormState = {
  farm: { value: null, error: false },
  retreats: { value: [], error: false },
};

export function useFarmAndRetreatsLinks() {
  const [farmAndRetreatsForm, setFarmAndRetreatsForm] =
    useState<FarmAndRetreatsFormState>({ ...initialFormState });

  const handleClearSelection = () => {
    setFarmAndRetreatsForm({ ...initialFormState });
  };

  const handleSelectItem =
    <T extends keyof FarmAndRetreatsFormState>(field: T) =>
    (item: FarmAndRetreatsFormState[T]["value"]) => {
      setFarmAndRetreatsForm((prevState) => ({
        ...prevState,
        [field]: { value: item, error: null },
      }));
    };

  const toggleFormError = () => {
    setFarmAndRetreatsForm((prevState) => ({
      ...prevState,
      farm: { ...prevState.farm, error: true },
      retreats: { ...prevState.retreats, error: true },
    }));
  };

  return {
    farmAndRetreatsForm,
    handleSelectItem,
    handleClearSelection,
    toggleFormError,
  };
}
